import React from 'react';
import styles from './PartnerList.module.css';
import { filterPartners, Partner } from 'requests/partners';
import {
  map,
  chunk,
} from 'lodash';

type PartnerListProps = {
  options: {
    size: string,
    center: any,
    resultCount: number,
    style: string,
  },
  partners: Partner[],
}

function formatAddress(address: string) {
  // Keep the last street-name word and its house number on the same line.
  return address.replace(
    /(\S+)\s+(\d[\dA-Za-z/+–-]*(?:\s+[A-Za-z])?)$/,
    (_, street, number) => `${street}\u00a0${number.replace(/\s+/g, '\u00a0')}`,
  );
}

function renderPartners(partners: Partner[], index: number, first=false, style='color') {
  return (
    <div className={ first ? styles.firstPage : styles.fullPage } key={ index }>
      <div className={ styles.container }>
        { map(partners, (partner) => (
          <p className={ styles.partner } key={ partner.id }>
            <strong>{ partner.index }.</strong>
            <span contentEditable suppressContentEditableWarning><span className={styles.partnerName}>{ partner.name }</span>, { formatAddress(partner.street1) }</span>
          </p>
        ))}
      </div>
      <footer>
        <img className={styles.claim} src={style === 'bw' ? '/there-you-go-dark-gray.svg' : '/there-you-go.svg'} alt="there you go" />
      </footer>
    </div>
  );
}

type configType = {
  [key: string]: [number, number],
};
const PAGE_SIZES: configType = {
  a4: [20, 60],
  a5: [16, 50],
};
const PartnerList: React.FC<PartnerListProps> = ({ options, partners }) => {
  const results = filterPartners(partners, options.center, options.resultCount);

  const [initalPartnersperPage, partnersPerPage] = PAGE_SIZES[options.size];

  return (
    <div className={ styles[`page-${options.size}`] }>
      { renderPartners(results.slice(0, initalPartnersperPage), -1, true, options.style) }
      { results.length > initalPartnersperPage && (
        map(
          chunk(results.slice(initalPartnersperPage), partnersPerPage),
          (partner, index) => renderPartners(partner, index, false, options.style),
        )
      ) }
    </div>
  );
};

export default PartnerList;
